import { InlineMessage } from '@/components/inline-message/InlineMessage'
import { kNewConversationTitle } from '@/chat-common/conversation_list/constants'
import { useNewChatMatterBoundAction } from '@/chat-common/new_chat/hooks/useNewChatMatterBoundAction'
import { NewChat } from '@/assets/icons'
import { Button } from '@/components/button/Button'
import { IconButton } from '@/components/icon-button/IconButton'

type NewChatMatterBoundButtonProps = {
  /**
   * If provided, called when the user clicks a CTA
   */
  onClick?: () => void
  /**
   * Whether the button is compact i.e displays as an icon only
   */
  iconOnly?: boolean
}

export default function NewChatMatterBoundButton({ iconOnly = false, onClick }: NewChatMatterBoundButtonProps) {
  const { handleButtonClick, clickDisabled, createError } = useNewChatMatterBoundAction(onClick)

  return (
    <>
      {iconOnly ? (
        <IconButton
          aria-label="Start new chat"
          color="primary"
          data-testid="new-chat-button-icon-only"
          disabled={clickDisabled}
          icon={<NewChat />}
          onClick={handleButtonClick}
          variant="plain"
          size="lg"
        />
      ) : (
        <Button
          aria-label="Start new chat"
          color="primary"
          data-testid="new-chat-button"
          disabled={clickDisabled}
          fullWidth
          onClick={handleButtonClick}
          title="New Chat"
          variant="filled"
        >
          {kNewConversationTitle}
        </Button>
      )}
      {createError && (
        <div className="mt-1">
          <InlineMessage variant="error">Error creating chat. Please try again.</InlineMessage>
        </div>
      )}
    </>
  )
}
